<div class="viewManagementButtons">
	@if (currentCameraLayout) {
		<div class="viewManagementButtonsContainer">
			@for (map of CameraLayoutMap?.get(currentCameraLayout)?.svgs | keyvalue: unsorted; track map) {
				<div
					class="screenPattern"
					mat-ripple
					(click)="selectCameraViewMode(map.key)"
					[class.active]="currentCameraViewMode === map.key"
				>
					<mat-icon [svgIcon]="map.value" />
				</div>
			}
		</div>
	}
</div>
